import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Guards the `/change-password` route itself: not logged in → bounce to
 * `/login`; logged in but nothing to force → bounce home (mirrors
 * `authGuard`'s login-page bounce). Otherwise allow.
 */
export const changePasswordPageGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.parseUrl('/login');
  }
  if (!authService.mustChangePassword()) {
    return router.parseUrl(authService.homeRoute());
  }
  return true;
};
